import React from "react"
import MetaTags from 'react-meta-tags';
import { Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import BlogList from "./BlogList"
import RightBar from "./RightBar"

const Index = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Parenting App | Journals</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Journals" breadcrumbItem="Journals" />
          <Row>
            <BlogList />
            {/* <RightBar /> */}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Index
